import { useTranslation } from 'react-i18next';
import type { AdminRange } from '@b4b/shared';

const RANGES: AdminRange[] = ['7d', '30d', '90d'];

export default function RangeSwitch({ value, onChange }: { value: AdminRange; onChange: (r: AdminRange) => void }) {
  const { t } = useTranslation();
  return (
    <div role="group" aria-label={t('admin.range.label')} className="flex rounded-xl bg-neutral-100 p-1 dark:bg-neutral-800">
      {RANGES.map((r) => (
        <button
          key={r}
          type="button"
          onClick={() => onChange(r)}
          aria-pressed={value === r}
          className={`min-h-[44px] flex-1 rounded-lg px-3 text-sm ${value === r ? 'bg-white font-medium shadow-sm dark:bg-neutral-700' : 'text-neutral-500'}`}
        >
          {t(`admin.range.${r}`)}
        </button>
      ))}
    </div>
  );
}
